import {
  asyncActionTypeFailure,
  asyncActionTypeRequest,
  asyncActionTypeSuccess,
} from '../types';
import cartTypes from '../types/cart';
import { initialCartState } from '../states/cart';

export default (state = initialCartState, action) => {
  switch (action.type) {
    // ADD_ORDER_TO_CART
    case asyncActionTypeRequest(cartTypes.ADD_ORDER_TO_CART):
      return {
        ...state,
        addOrderToCart: { ...state.addOrderToCart, loading: true, error: '' },
      };
    case asyncActionTypeSuccess(cartTypes.ADD_ORDER_TO_CART):
      return {
        ...state,
        addOrderToCart: {
          loading: false,
          data: action.response?.data || {},
          error: '',
        },
      };
    case asyncActionTypeFailure(cartTypes.ADD_ORDER_TO_CART):
      return {
        ...state,
        addOrderToCart: {
          loading: false,
          data: {},
          error: action.error || '',
        },
      };

    // GET_CART_DETAILS
    case asyncActionTypeRequest(cartTypes.GET_CART_DETAILS):
      return {
        ...state,
        cartDetails: { ...state.cartDetails, loading: true, error: '' },
      };
    case asyncActionTypeSuccess(cartTypes.GET_CART_DETAILS):
      return {
        ...state,
        cartDetails: {
          loading: false,
          data: action.response?.data || {},
          error: '',
        },
      };
    case asyncActionTypeFailure(cartTypes.GET_CART_DETAILS):
      return {
        ...state,
        cartDetails: {
          loading: false,
          data: {},
          error: action.error || '',
        },
      };

    // REMOVE_CART_ITEM
    case asyncActionTypeRequest(cartTypes.REMOVE_CART_ITEM):
      return {
        ...state,
        removeCartItem: { ...state.removeCartItem, loading: true, error: '' },
      };
    case asyncActionTypeSuccess(cartTypes.REMOVE_CART_ITEM):
      return {
        ...state,
        removeCartItem: {
          loading: false,
          data: action.response?.data || {},
          error: '',
        },
      };
    case asyncActionTypeFailure(cartTypes.REMOVE_CART_ITEM):
      return {
        ...state,
        removeCartItem: {
          loading: false,
          data: {},
          error: action.error || '',
        },
      };

    // CART_CHECKOUT
    case asyncActionTypeRequest(cartTypes.CART_CHECKOUT):
      return {
        ...state,
        cartCheckout: { ...state.cartCheckout, loading: true, error: '' },
      };
    case asyncActionTypeSuccess(cartTypes.CART_CHECKOUT):
      return {
        ...state,
        cartCheckout: {
          loading: false,
          data: action.response?.data || {},
          error: '',
        },
      };
    case asyncActionTypeFailure(cartTypes.CART_CHECKOUT):
      return {
        ...state,
        cartCheckout: {
          loading: false,
          data: {},
          error: action.error || '',
        },
      };

    default:
      return state;
  }
};
